<template>
  <div class="tw-p-6 tw-text-left">
    <div class="tw-max-w-xl">
      <h3 class="tw-text-lg tw-font-medium tw-text-slate-900">Container Refresh Frequency</h3>
      <p class="tw-mt-1 tw-text-sm tw-text-slate-500">
        Set how often your containers should be automatically updated when they are not in the "Urgent" window.
      </p>

      <div class="tw-mt-6 tw-grid tw-grid-cols-1 tw-gap-6">
        <div>
          <label for="interval" class="tw-block tw-text-sm tw-font-medium tw-text-slate-700">
            Refresh Interval
          </label>
          <select
            id="interval"
            v-model="selectedInterval"
            class="tw-mt-2 tw-block tw-w-full tw-rounded-lg tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-slate-900 tw-shadow-sm focus:tw-border-indigo-500 focus:tw-ring-indigo-500 sm:tw-text-sm"
          >
            <option v-for="opt in intervalOptions" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
          <p class="tw-mt-3 tw-text-xs tw-text-slate-400">
            * Note: Containers with ETA &le; 24h will still be updated every 1 hour for safety.
          </p>
        </div>

        <div class="tw-flex tw-justify-start">
          <button
            @click="saveSettings"
            :disabled="saving"
            class="tw-inline-flex tw-justify-center tw-rounded-lg tw-bg-slate-900 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-slate-800 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-slate-400 disabled:tw-opacity-50"
          >
            {{ saving ? 'Saving...' : 'Save Settings' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ProfileQuery from '@/gql/company/profile.gql';
import UpdateTrackingMutation from '@/gql/company/mutations/UpdateTrackingSettings.gql';


export default defineComponent({
  name: 'TrackingSettingsTab',
  data() {
    return {
      saving: false,
      selectedInterval: 24, // default
      intervalOptions: [
        { label: '12 Hours', value: 12 },
        { label: '18 Hours', value: 18 },
        { label: '24 Hours (Default)', value: 24 },
        { label: '36 Hours', value: 36 },
        { label: '48 Hours (2 Days)', value: 48 },
        { label: '72 Hours (3 Days)', value: 72 },
      ],
    };
  },
  apollo: {
    company: {
      query: ProfileQuery,
      result({ data }) {
        if (data && data.company){
          this.selectedInterval = data.company.containerRefreshInterval || 24;
        }
      },
    },
  },
  methods: {
    async saveSettings() {
      this.saving = true;
      try {
        await this.$apollo.mutate({
          mutation: UpdateTrackingMutation,
          variables: {
            interval: this.selectedInterval,
          },
        });
      } catch (error) {
        console.error('Error saving tracking settings:', error);
      } finally {
        this.saving = false;
      }
    }
  }
});
</script>